export async function preloadFilesToMemory(files: File[]): Promise<File[]> {
  const safeFiles = await Promise.all(files.map(preloadFileToMemory));

  return safeFiles;
}

export async function preloadFileToMemory(file: File): Promise<File> {
  try {
    const buffer = await file.arrayBuffer();
    return new File([buffer], file.name, {
      type: file.type,
      lastModified: file.lastModified,
    });
  } catch (error) {
    console.error("Failed to preload file into memory:", file.name, error);
    return file;
  }
}
